import { Address } from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/settings.pb';

type Props = {
  brandSettingAddress?: Address;
  isBrandSettingsEnabled: boolean;
  tcrBrandAddress?: Address;
};

/**
 * determineLocationAddress returns which address it should use based on the brand settings flag.
 *
 * When brand settings are disabled, it always uses the TCR brand address.
 * When brand settings are enabled, it prefers the brand settings address and falls back to the TCR brand address.
 *
 * @param params - address sources and feature flag
 * @param params.brandSettingAddress - address from brand settings
 * @param params.isBrandSettingsEnabled - controls which address source is prioritized
 * @param params.tcrBrandAddress - fallback address from TCR brand data
 * @returns the address to use based on the brand settings flag, either from brand settings or TCR brand data
 */

export const determineLocationAddress = ({ brandSettingAddress, isBrandSettingsEnabled, tcrBrandAddress }: Props) => {
  // disabled flag => always use the TCR brand's address
  if (!isBrandSettingsEnabled) {
    return tcrBrandAddress;
  }

  // enabled flag => use the brandSettings address if available (contains at least one non-empty value), otherwise fallback to the provided address
  const hasBrandSettingAddress = Boolean(
    brandSettingAddress?.address?.trim() ||
      brandSettingAddress?.address2?.trim() ||
      brandSettingAddress?.city?.trim() ||
      brandSettingAddress?.state?.trim() ||
      brandSettingAddress?.zipCode?.trim()
  );
  return hasBrandSettingAddress ? brandSettingAddress : tcrBrandAddress;
};
